let dirPath = 'games/page020_game0/';
let dirAudio = 'games/page020_game0/audio/';

let configGame = {
  autoCheckAllCorrect: true,
  removeInCorrects: true,
  correctBlock: false,
  rulesGame: {
    otherProperty: {
      sounds: [{ src: dirPath + 'audio/click.mp3', id: 'mouseup' }],
    },
    // itemsConfig: { shuffle: false, block: true },
    items: [
      {
        idGroup: 'source',
        idItem: 's01',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't01',
            correct: [{ idGroup: 'source', idItem: 's01' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's02',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't02',
            correct: [{ idGroup: 'source', idItem: 's02' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's03',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't03',
            correct: [{ idGroup: 'source', idItem: 's03' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's04',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't04',
            correct: [{ idGroup: 'source', idItem: 's04' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's05',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't05',
            correct: [{ idGroup: 'source', idItem: 's05' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's06',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't06',
            correct: [{ idGroup: 'source', idItem: 's06' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's07',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't07',
            correct: [{ idGroup: 'source', idItem: 's07' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's08',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't08',
            correct: [{ idGroup: 'source', idItem: 's08' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's09',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't09',
            correct: [{ idGroup: 'source', idItem: 's09' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's10',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't10',
            correct: [{ idGroup: 'source', idItem: 's10' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's11',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't11',
            correct: [{ idGroup: 'source', idItem: 's11' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's12',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't12',
            correct: [{ idGroup: 'source', idItem: 's12' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's13',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't13',
            correct: [{ idGroup: 'source', idItem: 's13' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's14',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't14',
            correct: [{ idGroup: 'source', idItem: 's14' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: { pos: { width: 792 }, margin: { right: 4 } },
      background: {
        text: {
          font: 'Garamond',
          size: '32px',
          textAlign: 'center',
          textBaseline: 'middle',
        },
      },
    },
    groups: [
      {
        idGroup: 'target',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 205 + 2, y: 181 + 2 },
            { x: 205 + 2, y: 338 + 2 },
            { x: 398 + 2, y: 181 + 2 },
            { x: 398 + 2, y: 338 + 2 },
            { x: 591 + 2, y: 181 + 2 },
            { x: 591 + 2, y: 338 + 2 },
            { x: 591 + 2, y: 494 + 2 },
            { x: 591 + 2, y: 651 + 2 },
            { x: 591 + 2, y: 808 + 2 },
            { x: 784 + 2, y: 181 + 2 },
            { x: 784 + 2, y: 338 + 2 },
            { x: 784 + 2, y: 494 + 2 },
            { x: 784 + 2, y: 651 + 2 },
            { x: 784 + 2, y: 808 + 2 },
          ],
        },
        otherProperty: {
          hooks: {
            autoResize: true,
            background: { color: 'rgba(255,255,255,0.01)' },
            positions: { pos: { width: 96, height: 96 } },
            items: [{ id: 'h01' }],
          },
        },
        items: [
          {
            id: 't01',
            otherProperty: {
              audio: ['a01'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't02',
            otherProperty: {
              audio: ['a02'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't03',
            otherProperty: {
              audio: ['a03'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't04',
            otherProperty: {
              audio: ['a04'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't05',
            otherProperty: {
              audio: ['a05'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't06',
            otherProperty: {
              audio: ['a06'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't07',
            otherProperty: {
              audio: ['a07'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't08',
            otherProperty: {
              audio: ['a08'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't09',
            otherProperty: {
              audio: ['a09'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't10',
            otherProperty: {
              audio: ['a10'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't11',
            otherProperty: {
              audio: ['a11'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't12',
            otherProperty: {
              audio: ['a12'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't13',
            otherProperty: {
              audio: ['a13'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't14',
            otherProperty: {
              audio: ['a14'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 1233, y: 196 }, // happy
            { x: 1627, y: 808 }, // sad
            { x: 1452, y: 541 }, // calm
            { x: 1249, y: 800 }, // angry
            { x: 1650, y: 460 }, // sleepy
            { x: 1224, y: 344 }, // hungry
            { x: 1036, y: 781 }, // scared
            { x: 1582, y: 170 }, // mummy
            { x: 1371, y: 162 }, // daddy
            { x: 1001, y: 189 }, // sister
            { x: 1439, y: 718 }, // brother
            { x: 1627, y: 625 }, // baby
            { x: 975, y: 478 }, // grandma
            { x: 1186, y: 517 }, // grandpa
          ],
        },
        itemsConfig: {
          background: { color: 'rgba(255,255,255,0.01)' },
          positions: {
            pos: { width: 219, height: 219 },
            // rows: 1,
            // margin: { right: 38 },
          },
        },
        // positions: {
        //   type: 'absolute',
        //   pos: { x: 80, y: 920 },
        // },
        items: [
          {
            id: 's01',
            background: {
              image: { src: dirPath + 'img/happy.png', pos: { width: 142, height: 129, x: 0, y: 6 } },
            },
            positions: { pos: { width: 142, height: 142 } },
          },
          {
            id: 's02',
            background: {
              image: { src: dirPath + 'img/sad.png', pos: { width: 93, height: 125, x: 16, y: 0 } },
            },
            positions: { pos: { width: 125, height: 125 } },
          },
          {
            id: 's03',
            background: {
              image: { src: dirPath + 'img/calm.png', pos: { width: 106, height: 120, x: 7, y: 0 } },
            },
            positions: { pos: { width: 120, height: 120 } },
          },
          {
            id: 's04',
            background: {
              image: { src: dirPath + 'img/angry.png', pos: { width: 105, height: 125, x: 7, y: 0 } },
            },
            positions: { pos: { width: 140, height: 140 } },
          },
          {
            id: 's05',
            background: {
              image: { src: dirPath + 'img/sleepy.png', pos: { width: 142, height: 113, x: 0, y: 14 } },
            },
            positions: { pos: { width: 142, height: 142 } },
          },
          {
            id: 's06',
            background: {
              image: { src: dirPath + 'img/hungry.png', pos: { width: 146, height: 117, x: 0, y: 14 } },
            },
            positions: { pos: { width: 146, height: 146 } },
          },
          {
            id: 's07',
            background: {
              image: { src: dirPath + 'img/scared.png', pos: { width: 133, height: 125, x: 0, y: 4 } },
            },
            positions: { pos: { width: 133, height: 133 } },
          },
          {
            id: 's08',
            background: {
              image: { src: dirPath + 'img/mummy.png', pos: { width: 91, height: 255, x: 82, y: 0 } },
            },
            positions: { pos: { width: 255, height: 255 } },
          },
          {
            id: 's09',
            background: {
              image: { src: dirPath + 'img/daddy.png', pos: { width: 100, height: 299, x: 99, y: 0 } },
            },
            positions: { pos: { width: 299, height: 299 } },
          },
          {
            id: 's10',
            background: {
              image: { src: dirPath + 'img/sister.png', pos: { width: 107, height: 208, x: 50, y: 0 } },
            },
            positions: { pos: { width: 208, height: 208 } },
          },
          {
            id: 's11',
            background: {
              image: { src: dirPath + 'img/brother.png', pos: { width: 107, height: 188, x: 40, y: 0 } },
            },
            positions: { pos: { width: 188, height: 188 } },
          },
          {
            id: 's12',
            background: {
              image: { src: dirPath + 'img/baby.png', pos: { width: 85, height: 137, x: 26, y: 0 } },
            },
            positions: { pos: { width: 137, height: 137 } },
          },
          {
            id: 's13',
            background: {
              image: { src: dirPath + 'img/grandma.png', pos: { width: 105, height: 247, x: 71, y: 0 } },
            },
            positions: { pos: { width: 247, height: 247 } },
          },
          {
            id: 's14',
            background: {
              image: { src: dirPath + 'img/grandpa.png', pos: { width: 91, height: 234, x: 71, y: 0 } },
            },
            positions: { pos: { width: 234, height: 234 } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  // blockCheck: true,
  mainImage: {
    imagePath: dirPath + 'img/bcg.webp',
  },
  fullscreen: true,
  mixinEngine: 'dnd',
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + '15_happy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + '16_sad.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + '17_calm.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: dirAudio + '18_angry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a05',
      src: dirAudio + '19_sleepy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a06',
      src: dirAudio + '20_hungry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a07',
      src: dirAudio + '21_scared.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a08',
      src: dirAudio + '22_mummy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a09',
      src: dirAudio + '23_daddy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a10',
      src: dirAudio + '24_sister.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a11',
      src: dirAudio + '25_brother.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a12',
      src: dirAudio + '26_baby.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a13',
      src: dirAudio + '27_grandma.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a14',
      src: dirAudio + '28_grandpa.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page020_game0/img/audioOn.png', iconOff: 'games/page020_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
  ],
  configGame: configGame,
};

export default dataConfig;
